const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
    <style>
        .container-video {
            position: relative;
        }
        .video-js {
            width: 660px;
            height: 370px;
        }
        .vjs-poster{
            background-size: 100%!important;
        }
        .vjs-default-skin.vjs-paused .vjs-big-play-button {
            display: none;
        }
        .banner-label {
            background-color: #F96D01;
            position: absolute;
            padding: 10px 20px;
            border-radius: 0px 0px 0px 12px;
            font-size: 16px;
            color: #FFFFFF;
            top: 0;
            right: 0;
            opacity: 0.9;
        }
        .bg-live {
            background-color: #559808 !important;
        }
        .bg-finished {
            background-color: #424242
        }
        .banner-hide {
            display: none;
        }
        .vjs-error .vjs-error-display .vjs-modal-dialog-content {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .vjs-error .vjs-error-display:before {
            display: none;
        }
    </style>
</template>`;
styleElement.register("video-player-style");
